/**
 * lodash工具函数
 * 按需引入lodash常用函数，避免全量引入导致包体积增大
 */
// 只导入需要的函数，而不是整个lodash
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import find from 'lodash/find'
import filter from 'lodash/filter'
import map from 'lodash/map'
import reduce from 'lodash/reduce'
import sortBy from 'lodash/sortBy'
import round from 'lodash/round'

// 导出常用函数
export {
  debounce,
  throttle,
  cloneDeep,
  isEmpty,
  isEqual,
  find,
  filter,
  map,
  reduce,
  sortBy,
  round
}

// 导出所有常用函数的对象
export const lodashUtils = {
  debounce,
  throttle,
  cloneDeep,
  isEmpty,
  isEqual,
  find,
  filter,
  map,
  reduce,
  sortBy,
  round
}

export default lodashUtils